import { uiText, useUiLanguage } from '../../../../../utils/uiTranslation';
import React from 'react';

const WidgetLibraryModal = ({
  isOpen = false,
  copy,
  categories = [],
  onClose,
  onAddWidget,
  isRTL = false
}) => {
  useUiLanguage();
  if (!isOpen) return null;

  return (
    <div className="analytics-library-backdrop" onClick={onClose}>
      <div
        className={`analytics-library-modal${isRTL ? ' rtl' : ''}`}
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={copy.title}
      >
        <div className="analytics-library-head">
          <div>
            <h3>{copy.title}</h3>
            <p>{uiText(copy.subtitle)}</p>
          </div>
          <button type="button" className="analytics-library-close" onClick={onClose}>
            <i className="fa-solid fa-xmark" />
            <span>{copy.close}</span>
          </button>
        </div>

        <div className="analytics-library-body">
          {categories.map((category) => (
            <section key={category.id} className="analytics-library-section">
              <div className="analytics-library-section-title">{uiText(category.label)}</div>
              <div className="analytics-library-grid">
                {category.widgets.map((widget) => (
                  <article
                    key={widget.id}
                    className={`analytics-library-card${widget.isAdded ? ' added' : ''}${widget.hasReadyData ? ' ready' : ''}`}
                  >
                    <div className="analytics-library-card-top">
                      <div className="analytics-library-card-title-group">
                        <div className="analytics-library-card-title">{uiText(widget.label)}</div>
                        {widget.dataLayerLabel ? (
                          <span className={`analytics-library-type-pill${widget.dataLayer ? ` ${widget.dataLayer}` : ''}`}>
                            {widget.dataLayerLabel}
                          </span>
                        ) : null}
                      </div>
                      <span className={`analytics-library-status${widget.hasReadyData ? ' ready' : ''}`}>
                        {widget.hasReadyData ? copy.exampleDataReady : copy.exampleDataMissing}
                      </span>
                    </div>

                    <div className="analytics-library-card-meta">
                      <span>{widget.defaultGraphLabel}</span>
                      <span className="analytics-library-card-dot" aria-hidden="true" />
                      <span>{copy.graphCount(widget.graphCount)}</span>
                    </div>

                    <div className="analytics-library-card-actions">
                      <button
                        type="button"
                        className={`analytics-library-add-btn${widget.isAdded ? ' added' : ''}`}
                        onClick={() => {
                          if (!widget.hasReadyData || widget.isAdded) return;
                          onAddWidget?.(widget.id);
                        }}
                        disabled={widget.isAdded || !widget.hasReadyData}
                      >
                        {widget.isAdded ? copy.added : copy.add}
                      </button>
                    </div>
                  </article>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WidgetLibraryModal;
